import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Modal from '@material-ui/core/Modal';
import '../view/css/Calendar.css';
import * as firebase from 'firebase';
import '../view/css/eventfeed2.css'
import { Link } from "react-router-dom";
import { EditEvent } from '../model/event_model/EditEvent';
import { removeEventFnc} from '../model/calendar_model/removeEventFnc';

const localizer = momentLocalizer(moment);

class CalendarComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectEvent: {},
            is_affiliate: false,
            events: this.props.userEvents,
        };
    }

    handleOpen = () => this.setState({ showModal: true });
    handleClose = () => this.setState({ showModal: false });

    handleRemove = async (event_title) => {
        console.log("ENTERING HANDLE REMOVE");
        const user = await firebase.auth().currentUser;
        const firestore = await firebase.firestore();

        console.log("This is user email");
        console.log(user);

        if (user != null) {
            const db = firestore.collection("Users").doc(user.email);
            const doc = db.get().then((doc) => {
                if (doc.exists) {
                    removeEventFnc(firestore, event_title, user, this.props.noFetchData);
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });

        }
    }

    checkUser = () => {
        return firebase.auth().currentUser.email == this.state.selectEvent.email;
    }

    body =  (user) => (
        <div className="DisplayCard" >
            <div className="EventTitle">
                {this.state.selectEvent.title}
            </div>
            <div className="ContentContainer">
                <div className="ImageContainer" >
                    {(this.state.selectEvent.pictures === "picture" &&
                        <img alt="placeholder" className="breezeHolder" src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} />) || (
                            <img alt="uploaded" className="loadedImage" src={this.state.selectEvent.pictures} />)
                    }
                </div>
                <hr className="divider" />
                <div className="EventDetailsContainer">
                    <div className="affiliateName">
                        {this.state.selectEvent.affiliate}
                    </div>
                    <div className="timeContainer">
                        <div className="time">
                            <b className="bold">Start</b>
                            {moment(this.state.selectEvent.start).format("MMM D, YYYY [at] h:mm a")}
                        </div>
                        <div className="time">
                            <b className="bold">End</b>
                            {moment(this.state.selectEvent.end).format("MMM D, YYYY [at] h:mm a")}
                        </div>
                    </div>
                    <div className="location">
                        <b className="bold">Location: </b>
                        {this.state.selectEvent.location}
                    </div>
                    <div className="eventdescription">
                        {this.state.selectEvent.description}
                    </div>
                    <div className="ButtonContainer">
                        {this.state.selectEvent.email != user.email && !this.checkUser() && <button className="cardButton" onClick={() => { this.handleRemove(this.state.selectEvent.title) && this.handleClose() }}>
                            Remove Event
                        </button>}
                        <Link className="cardButton"
                            to={{
                                pathname: `/Affiliate/${this.state.selectEvent.affiliate}`,
                                state: { name: this.state.selectEvent.affiliate, id: this.state.selectEvent.email }
                            }} >
                            View Affiliate
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )

    getUser = async () => {
        const user = await firebase.auth().currentUser;
        return user;
    }

    render() {

        return (
            <div className="PopupCalendar">
                <Calendar
                    localizer={localizer}
                    popup={false}
                    onSelectEvent={events => this.setState({ selectEvent: events, showModal: true })}
                    defaultDate={new Date()}
                    defaultView="month"
                    events={this.props.userEvents}
                    style={{ height: "90vh" }}
                />
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleClose}
                    onBackdropClick={this.handleClose}
                >
                    {this.body(this.getUser())}
                </Modal>
            </div>
        );
    }
}


export default CalendarComponent;